import { WarningPrimaryModal } from "./WarningPrimaryModal";

export default WarningPrimaryModal;
